import {
  DELETE_PATIENT_UPLOADED_FILES,
  SET_PATIENT_UPLOADED_FILES,
} from '../actions';
import {
  SET_ANDROLOGY_DATA,
  RESET_ANDROLOGY_DATA,
} from '../actions/andrologyAction';
import { patientInitialState } from './initialState';

export const initialState = {
  selectedPatientData: {
    isFetched: false,
    patient: patientInitialState,
    patientFiles: [],
  },
  hsa: {
    id: null,
    isReportStarted: false,
    createdBy: '',
    modifiedBy: '',
    reportId: null,
    sampleCollectedAt: null,
    receivedByLabAt: null,
    patientDetails: {
      date: '',
      abstinenceDays: '',
      collectedAtLab: 'Yes',
      sample: 'Complete',
      sampleReceivedBy: '',
      sampleReceivedByWitness: '',
      sampleProcessedBy: '',
      sampleProcessedByWitness: '',
    },
    seminalFluidAnalysis: {
      appearance: '',
      liquefactionTime: '',
      viscosity: '',
      volume: '',
      ph: '',
      agglutination: '',
      roundCellCount: '',
    },

    spermAnalysis: {
      spermCount: '',
      totalCount: '',
      motility: '',
      progression: '',
      nonProgression: '',
      immotile: '',
      viability: '',
      morphologyNormal: '',
      morphologyAbnormal: '',
    },
    otherDetails: {
      interpretation: '',
      comments: '',
      embryologist: '',
    },
  },
  qsa: {
    id: null,
    isReportStarted: false,
    createdBy: '',
    modifiedBy: '',
    reportId: null,
    sampleCollectedAt: null,
    receivedByLabAt: null,
    patientDetails: {
      date: '',
      abstinenceDays: '',
      collectedAtLab: 'Yes',
      sample: 'Complete',
      sampleReceivedBy: '',
      sampleReceivedByWitness: '',
      sampleProcessedBy: '',
      sampleProcessedByWitness: '',
    },
    seminalFluidAnalysis: {
      appearance: '',
      liquefactionTime: '',
      viscosity: '',
      volume: '',
      ph: '',
      agglutination: '',
      roundCellCount: '',
    },
    spermAnalysis: {
      spermCount: '',
      totalCount: '',
      motility: '',
      progression: '',
      nonProgression: '',
      immotile: '',
      viability: '',
      morphologyNormal: '',
      morphologyAbnormal: '',
    },
    qualityAnalysis: {
      head: {
        tapered: '',
        pyriform: '',
        amorphous: '',
        roundHead: '',
        macrocephalic: '',
        microcephalic: '',
        doubleHead: '',
        cytoplasmicDroplet: '',
        vacuolatedSpermHead: '',
      },
      midpiece: {
        bentNeck: '',
        asymmetrical: '',
        thin: '',
        thick: '',
      },
      tail: {
        coiledTail: '',
        shortTail: '',
        brokenTail: '',
      },
    },
    otherDetails: {
      interpretation: '',
      comments: '',
      embryologist: '',
    },
  },
  dfi: {
    id: null,
    isReportStarted: false,
    createdBy: '',
    modifiedBy: '',
    reportId: null,
    sampleCollectedAt: null,
    receivedByLabAt: null,
    patientDetails: {
      date: '',
      abstinenceDays: '',
      collectedAtLab: 'Yes',
      sample: 'Complete',
      sampleReceivedBy: '',
      sampleReceivedByWitness: '',
      sampleProcessedBy: '',
      sampleProcessedByWitness: '',
    },
    seminalFluidAnalysis: {
      appearance: '',
      liquefactionTime: '',
      viscosity: '',
      volume: '',
      ph: '',
      agglutination: '',
      roundCellCount: '',
    },
    spermAnalysis: {
      spermCount: '',
      totalCount: '',
      motility: '',
      progression: '',
      nonProgression: '',
      immotile: '',
      viability: '',
      morphologyNormal: '',
      morphologyAbnormal: '',
    },
    qualityAnalysis: {
      head: {
        tapered: '',
        pyriform: '',
        amorphous: '',
        roundHead: '',
        macrocephalic: '',
        microcephalic: '',
        doubleHead: '',
        cytoplasmicDroplet: '',
        vacuolatedSpermHead: '',
      },
      midpiece: {
        bentNeck: '',
        asymmetrical: '',
        thin: '',
        thick: '',
      },
      tail: {
        coiledTail: '',
        shortTail: '',
        brokenTail: '',
      },
    },
    dfiDetails: {
      dnaFregmentationIndex: '',
      dfiImagesToBeAttached: 'No',
      dfiImages: [],
    },
    otherDetails: {
      interpretation: '',
      comments: '',
      embryologist: '',
    },
  },
  sfr: {
    id: null,
    isReportStarted: false,
    createdBy: '',
    modifiedBy: '',
    reportId: null,
    sampleCollectedAt: null,
    receivedByLabAt: null,
    patientDetails: {
      date: '',
      abstinenceDays: '',
      collectedAtLab: 'Yes',
      sample: 'Complete',
      sampleReceivedBy: '',
      sampleReceivedByWitness: '',
      sampleProcessedBy: '',
      sampleProcessedByWitness: '',
      sourceOfSperm: 'Ejaculate',
      sourceOfSpermOther: '',
    },
    seminalFluidAnalysis: {
      appearance: '',
      liquefactionTime: '',
      viscosity: '',
      volume: '',
      ph: '',
      agglutination: '',
      roundCellCount: '',
    },
    spermAnalysis: {
      spermCount: '',
      totalCount: '',
      motility: '',
      progression: '',
      nonProgression: '',
      immotile: '',
      viability: '',
      morphologyNormal: '',
      morphologyAbnormal: '',
    },
    cryopreservation: {
      semenCryoPreserved: '',
      purpose: '',
      purposeOther: '',
      noOfVialsStored: '',
      tankNo: '',
      canisterNo: '',
      cane: '',
      freezingDuration: {
        years: '',
        months: '',
      },
      dateOfExpiry: null,
      samepleShiftedBy: '',
      witness: '',
      fateOfRemainingVials: '',
      fateOfRemainingVialsOther: '',
    },
    freezingInventory: {
      CryopreservationDetails: [
        {
          dateOfCryopreservation: '',
          numberOfVialsStored: '',
          dateOfThawing: '',
          purposeOfThawing: '',
          numberOfVialsThawed: '',
          numberOfVialsRemaining: '',
        },
      ],
      dateOfExpiry: null,
    },
    otherDetails: {
      embryologist: '',
      comments: '',
      date: null,
    },

    isMoreSampleSelected: false,
    parentId: null,
  },
  iui: {
    id: null,
    isReportStarted: false,
    createdBy: '',
    modifiedBy: '',
    reportId: null,
    sampleCollectedAt: null,
    receivedByLabAt: null,
    patientDetails: {
      date: '',
      abstinenceDays: '',
      collectedAtLab: 'Yes',
      sample: 'Complete',
      sampleReceivedBy: '',
      sampleReceivedByWitness: '',
      sampleProcessedBy: '',
      sampleProcessedByWitness: '',
      sourceOfSample: 'Self',
      sourceOfSampleSelf: '',
      sourceOfSampleDonorBank: '',
      sourceOfSampleDonorCode: '',
      sourceOfSampleSelfOther: '',
    },
    spermPrewashfindings: {
      firstEjaculate: {
        volume: '',
        spermCount: '',
        totalCount: '',
        totalMotility: '',
        progressive: '',
        nonProgressive: '',
        immotile: '',
      },
      secondEjaculate: {
        hasSecondEjaculate: 'No',
        volume: '',
        spermCount: '',
        totalCount: '',
        totalMotility: '',
        progressive: '',
        nonProgressive: '',
        immotile: '',
      },
    },
    spermPostwashFindings: {
      volume: '',
      spermCount: '',
      totalCount: '',
      totalMotility: '',
      progressive: '',
      nonProgressive: '',
      immotile: '',
      totalMotileCount: '',
      spermWashingProcedure: 'Density Gradient',
    },
    otherDetails: {
      embryologist: '',
      interpretation: '',
      comments: '',
    },
  },
  refresh: false,
  selectedProcess: '',
  isNewReport: false,
};

const updateNestedState = (state, keyPath, value) => {
  if (!keyPath) {
    console.error('Invalid keyPath:', keyPath);
    return state; // Return original state if keyPath is invalid
  }

  const keys = keyPath.split('.');
  const newState = { ...state };

  let current = newState;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];

    if (!key || !(key in current)) {
      console.error('Invalid key in path:', key);
      return state; // If any key is invalid, return the original state
    }

    // Ensure immutability for arrays and objects
    if (Array.isArray(current[key])) {
      current[key] = [...current[key]];
    } else {
      current[key] = { ...current[key] };
    }

    current = current[key];
  }

  const finalKey = keys[keys.length - 1];

  if (finalKey) {
    if (value !== null && value !== undefined) {
      current[finalKey] = value; // Only update if the final key is valid
    }
  } else {
    console.error('Empty key at the end of the keyPath');
  }

  return newState;
};

const andrologyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ANDROLOGY_DATA:
      return updateNestedState(
        state,
        action.payload.keyPath,
        action.payload.value,
      );
    case RESET_ANDROLOGY_DATA:
      return initialState;

    case SET_PATIENT_UPLOADED_FILES:
      const newUploadedFiles = [...state.selectedPatientData.patientFiles];
      newUploadedFiles.push(action.payload);
      return {
        ...state,
        selectedPatientData: {
          ...state.selectedPatientData,
          patientFiles: newUploadedFiles,
        },
      };
    case DELETE_PATIENT_UPLOADED_FILES:
      const newFiles = state.selectedPatientData.patientFiles.filter(
        (uploadedFile) => uploadedFile?.file?.fileId !== action.payload.fileId,
      );
      return {
        ...state,
        selectedPatientData: {
          ...state.selectedPatientData,
          patientFiles: newFiles,
        },
      };

    default:
      return state;
  }
};

export default andrologyReducer;
